/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonalAssetTypeUsageDto
 */
export interface PersonalAssetTypeUsageDto {
    /**
     * Asset type key
     * @type {string}
     * @memberof PersonalAssetTypeUsageDto
     */
    type: string;
    /**
     * Number of users with this asset type
     * @type {number}
     * @memberof PersonalAssetTypeUsageDto
     */
    usersCount: number;
    /**
     * Total number of assets of this type
     * @type {number}
     * @memberof PersonalAssetTypeUsageDto
     */
    assetsCount: number;
}

export function PersonalAssetTypeUsageDtoFromJSON(json: any): PersonalAssetTypeUsageDto {
    return PersonalAssetTypeUsageDtoFromJSONTyped(json, false);
}

export function PersonalAssetTypeUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetTypeUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'usersCount': json['usersCount'],
        'assetsCount': json['assetsCount'],
    };
}

export function PersonalAssetTypeUsageDtoToJSON(value?: PersonalAssetTypeUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'usersCount': value.usersCount,
        'assetsCount': value.assetsCount,
    };
}

